import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AtpDialogService } from 'src/app/atp-core/components/atp-dialog/atp-dialog.service';
import { AtpHttpErrorsService, AtpHttpErrorHandler } from 'src/app/atp-core/services/atp-http-errors.service';
import {
  IAtpPagination,
  IAtpHistory,
  AtpHistoryData,
  IAtpSelectItem,
  IAtpAddEditInfo,
  AtpAddEditData
} from 'src/app/atp-core/atp-core';
import { AtpHistoryComponent } from 'src/app/atp-core/atp-dynamic-table-full-crud/atp-history/atp-history.component';
import { AtpBasePageComponent } from 'src/app/atp-core/atp-base-page-component';
import { DevService } from 'src/app/services/dev.service';
import {ComponentType} from "@angular/cdk/portal";
import {AtpSettingsComponent} from "../../atp-core/components/atp-settings/atp-settings.component";

@Component({
  selector: 'nav-menu',
  templateUrl: './nav-menu.component.html',
  animations: [
    trigger('slide', [
      state('closed', style({
        width: '71px'
      })),
      state('open', style({
        width: '250px'
      })),
      transition('* => closed', [
        animate('0.2s')
      ]),
      transition('* => open', [
        animate('0.3s')
      ]),
    ]),
  ],
})
export class NavMenuComponent implements OnInit {

  constructor(public api: HttpService, protected httpErrors: AtpHttpErrorsService, protected atpDialog: AtpDialogService, public devService: DevService) { }

  toggle: boolean = true;

  ngOnInit() {
  }

  @HostBinding('@slide') get slideState(): string {
    return this.toggle ? 'closed' : 'open';
  }

  @Input() parent: AtpBasePageComponent;

  sharedHistoryClick(): void {
    this.parent.isBlockedPage = true;
    this.api.historyHistory('', null, 1, 15).subscribe(
      (result: IAtpPagination<IAtpHistory>) => {
        let userIdsItems = {};
        for (const item of result.items) {
          if (!item.userId) {
            continue;
          }
          if (!userIdsItems[item.userId]) {
            userIdsItems[item.userId] = [];
          }
          userIdsItems[item.userId].push(item);
        }
        this.getUserNamesByIds(null, userIdsItems, result);
        this.parent.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.sharedHistoryClick(); }, this.parent, [new AtpHttpErrorHandler(400, err.error)]);
      }
    );
  }

  protected getUserNamesByIds(modelId: any, userIdsItems: any, data: IAtpPagination<IAtpHistory>): void {
    this.parent.isBlockedPage = true;
    this.api.getUserNamesByIds(Object.getOwnPropertyNames(userIdsItems)).subscribe(
      (users: IAtpSelectItem[]) => {
        for (const key in userIdsItems) {
          const user = users.find(x => x.id == key);
          for (const item of userIdsItems[key]) {
            item.userName = user.value;
            item.roleName = (<any>user).roleName;
          }
        }

        this.atpDialog.open(AtpHistoryComponent, { data: new AtpHistoryData('History', 'history', modelId, data, null, true) });

        // this.getHistoryContainer(new AtpHistoryData('History', 'history', modelId, data));
        this.parent.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getUserNamesByIds(modelId, userIdsItems, data); }, this.parent, [new AtpHttpErrorHandler(400, err.error)]);
      }
    );
  }

  showSettings(): void {
    this.parent.isBlockedPage = true;
    this.api.getSettings().subscribe(
      (result: IAtpAddEditInfo) => {
        this.parent.isBlockedPage = false;
        return this.atpDialog.open(AtpSettingsComponent, { data: new AtpAddEditData('Settings', result.model, result, null,  undefined) });
      },
      err => {
        this.httpErrors.process(err.status, () => { this.showSettings(); }, this.parent, [new AtpHttpErrorHandler(400, err.error)]);
      }
    );
  }
}
